// extracted by mini-css-extract-plugin
module.exports = {"drawerContainer":"DrawerContainer_drawerContainer__FAYJT","drawerBlock":"DrawerContainer_drawerBlock__ozpGm"};